import * as React from 'react';
import './index.css';
import ResourcePosition from '@sailor/mkt-resource-position-sdk';
import { ChannelCommonListPageLoganType, logan } from '../../../utils/Logan';

interface Props {
  apiData?: any;
}
export default class HeaderMKTResource extends React.Component<Props, any> {
  // eslint-disable-next-line react/no-unused-class-component-methods
  comRef: any
  constructor(props: Props) {
    super(props);
    this.parseDeliveryData();
  }
  parseDeliveryData() {
    const bannerData = this.props.apiData?.json_data?.resourceNewEntityDTO || {};
    const inputParams = this.props.apiData?.json_data?.inputParams || {};
    if (bannerData) {
      this.setState({
        deliveryData: bannerData,
        inputParams
      });
    }
  }
  componentDidMount(): void {
    this.parseDeliveryData();
  }
  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (prevProps.apiData !== this.props.apiData) {
      this.parseDeliveryData();
    }
  }
  render() {
    if (this.state.deliveryData) {
      const { layout_info } = this.props.apiData || {};
      const {
        margin_top, margin_bottom, margin_left, margin_right
      } = layout_info || {};
      logan(ChannelCommonListPageLoganType.Main, {
        msg: 'ResourcePosition Render',
      });
      return (
        <view
          className="container" style={{
            marginTop: margin_top || 0, marginBottom: margin_bottom || 0, marginLeft: margin_left || 0, marginRight: margin_right || 0
          }}
        >
          <ResourcePosition
            ref={(ref) => {
              // eslint-disable-next-line react/no-unused-class-component-methods
              this.comRef = ref;
            }}
            type="PULL"
            id={this.state.deliveryData.channelId}
            lxConfig={{ cid: Mach.env?.schemeParams?.cid || '', lxParams: {} }}
            inputParams={this.state.inputParams}
            data={this.state.deliveryData}
          />
        </view>
      );
    }
    return null;
  }
}
